var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "vip_card_list_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", { staticClass: "label" }, [_vm._v("选择菜单")]),
      _c(
        "el-form-item",
        {
          attrs: {
            rules: [{ required: true, message: "菜单不可为空" }],
            prop: "category_id",
          },
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: "请选择菜单",
                clearable: "",
                filterable: "",
              },
              model: {
                value: _vm.value.config.category_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "category_id", $$v)
                },
                expression: "value.config.category_id",
              },
            },
            _vm._l(_vm.menuListFilter, function (menu) {
              return _c("el-option", {
                key: menu.id,
                attrs: {
                  label: menu.show_name,
                  value: menu.id,
                  disabled: menu.disabled,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sort line_number" },
        [
          _c(
            "div",
            { staticClass: "label" },
            [
              _vm._v(" 产品列表显示模式 "),
              _c(
                "el-tooltip",
                { attrs: { effect: "dark", placement: "top" } },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(
                      " 选择「显示固定行数的商品」，表示共显示所设行数的商品，可控制底下是否显示查看更多；"
                    ),
                    _c("br"),
                    _vm._v(
                      "选择「上滑无限加载商品」，表示每次上滑加载所设行数的商品。 "
                    ),
                  ]),
                  _c("span", { staticClass: "tips" }, [
                    _vm._v(" 说明 "),
                    _c("i", { staticClass: "el-icon el-icon-warning-outline" }),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [
                  {
                    required: true,
                    validator: function (rule, value, callback) {
                      return _vm.checkNumber(rule, value, callback)
                    },
                    trigger: "change",
                  },
                ],
                prop: "line_number",
              },
            },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入商品展示行数" },
                  model: {
                    value: _vm.value.config.line_number,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "line_number", $$v)
                    },
                    expression: "value.config.line_number",
                  },
                },
                [
                  _c("template", { slot: "prepend" }, [_vm._v("显示")]),
                  _c("template", { slot: "append" }, [_vm._v("行")]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                rules: [
                  {
                    required: true,
                    trigger: "change",
                  },
                ],
                prop: "list_show_type",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.value.config.list_show_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.value.config, "list_show_type", $$v)
                    },
                    expression: "value.config.list_show_type",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(" 显示固定行数的商品 "),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                              },
                            ],
                            prop: "list_show_more",
                          },
                        },
                        [
                          _vm._v(" 底部显示「查看更多」按钮 "),
                          _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            model: {
                              value: _vm.value.config.list_show_more,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.value.config,
                                  "list_show_more",
                                  $$v
                                )
                              },
                              expression: "value.config.list_show_more",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "radio" },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(" 上滑无限加载商品 "),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }